import React from 'react';
import { useTranslation } from 'react-i18next';

/** Ürün görseli yoksa gösterilen placeholder */
function ImagePlaceholder({ emoji, color }) {
  return (
    <div
      className={`w-full h-full bg-gradient-to-br ${color || 'from-stone-800 to-stone-700'}
                  flex items-center justify-center select-none`}
    >
      <span className="text-5xl opacity-60">{emoji || '🍽️'}</span>
    </div>
  );
}

export default function MenuItemCard({ item, lang }) {
  const { t } = useTranslation();

  const name = item[`name_${lang}`] || item.name_pl || item.name_tr || '';
  const desc = item[`desc_${lang}`] || item.desc_pl || '';

  // Her kart için placeholder emoji/renk (ikon alanından da okunabilir)
  const emoji = item.icon || item.placeholderEmoji || '🍽️';
  const color = item.placeholderColor || 'from-stone-800 to-stone-700';

  return (
    <article
      id={`item-${item.id}`}
      className="
        group relative flex bg-bistro-card rounded-2xl overflow-hidden
        border border-bistro-border transition-all duration-300 ease-out
        hover:border-bistro-bronze hover:shadow-card-hover hover:-translate-y-0.5
        animate-fadeInUp
      "
    >
      {/* Image area — 30% width */}
      <div className="w-28 flex-shrink-0 relative overflow-hidden">
        {item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <ImagePlaceholder emoji={emoji} color={color} />
        )}
      </div>

      {/* Content */}
      <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
        <div>
          <h3 className="font-sans font-semibold text-bistro-cream text-sm leading-snug line-clamp-1">
            {name}
          </h3>
          {desc && (
            <p className="mt-1 font-sans text-bistro-muted text-xs leading-relaxed line-clamp-2">
              {desc}
            </p>
          )}
        </div>

        {/* Price */}
        <div className="mt-2 flex items-end justify-end">
          <span className="font-sans font-bold text-bistro-gold text-base tabular-nums">
            {item.price?.toFixed(2)}
            <span className="text-xs font-medium text-bistro-amber ml-0.5">
              {t('menu.currency')}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}
